// import { useLazyQuery } from "@apollo/client";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useForm, useWatch } from "react-hook-form";
import { CREATE_PAYMENT } from "../apollo/mutations";
import closeModal from "../common/closeModal";
import dayjs from "dayjs";
import { useEffect } from "react";
import { LIST_SALES } from "../apollo/queries";

const defaultValues = {
  customer_id: "",
  received_amount: "",
  paying_type: null,
  description: "",
  payment_date: dayjs(),
  sale_id: null
};

const useCreatePayment = (customer, refetch) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues });

  const [submit] = useMutation(CREATE_PAYMENT);

  const [fetchSalesList, { data: salesData }] = useLazyQuery(LIST_SALES);

  console.log("salesData", salesData);

  useEffect(() => {
    if (customer?.walk_in == true) {
      fetchSalesList({
        variables: {
          customerId: customer?.id,
          invoiceNo: null,
        },
      });
    }
  }, [customer]);

  useEffect(() => {
    if (!watch("payment_date")) {
      setValue("payment_date", dayjs().toDate());
    }
  }, [setValue, watch]);

  const selectedSale = useWatch({ control, name: "sale_id" });

  useEffect(() => {
    if (customer?.walk_in === true && selectedSale?.due) {
      setValue("received_amount", selectedSale.due);
    }
  }, [selectedSale, customer, setValue]);

  // useEffect(() => {
  //   if (customer?.walk_in == true) {
  //     const subscription = watch((value, { name }) => {
  //       if (name === "sale_id" && value?.sale_id?.due) {
  //         setValue("received_amount", value.sale_id.due);
  //       }
  //     });
  //     return () => subscription.unsubscribe();
  //   }
  // }, [watch, setValue, customer]);

  const onCreatePayment = async (data) => {
    try {
      console.log("data", data);
      let payload = {
        variables: {
          input: {
            customer_id: customer?.id,
            payment_date: data?.payment_date,
            received_amount:
              customer?.walk_in == true
                ? data?.sale_id?.due
                : parseFloat(data?.received_amount),
            paying_type: data?.paying_type.value,
            description: data?.description,
            sale_id: data?.sale_id?.value,
          },
        },
      };

      console.log("payload", payload);

      let res = await submit(payload);
      setValue("sale_id", null); 
      reset({ ...defaultValues, paying_type: null, sale_id: null });
      closeModal("createpayment");
      refetch();
      console.log("res", res);
    } catch (error) {
      console.log("Mutation error:", error.message);
    }
  };

  const onCancel = () => {
    setValue("sale_id", null); 
    reset({ ...defaultValues, paying_type: null, sale_id: null });
    closeModal("createpayment");
  };

  return {
    values: {
      control,
      errors,
      getValues,
      salesList: salesData?.listSales?.map((x) => ({
        label: x.invoice_no,
        value: x.id,
        due: x.due,
      })),
    },
    functions: {
      onSubmit: handleSubmit(onCreatePayment),
      onCancel,
    },
  };
};

export default useCreatePayment;
